
<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
            <v-row class="d-flex justify-center mt-3">
                <v-col cols="3">
                    <v-text-field
                        label="Nome da Gerência"
                        v-model="form.filters.nome"
                        outlined
                        dense
                    ></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                        label="Sigla da Gerência"
                        v-model="form.filters.sigla"
                        outlined
                        dense
                    ></v-text-field>
                </v-col>
                <v-col cols="5">
                  <v-autocomplete
                  v-model="form.filters.secretariaId"
                  label="Secretaria Executiva"
                  dense
                  outlined
                  :items="form.lists.listaSecretarias"
                  item-text="nome"
                  item-value="codigo"
                  return-object
                  />
                </v-col>
              </v-row>
              <v-row class="d-flex justify-center mt-3">
              <sigfoco-select-ativo
                  :cols="2"
                  v-model="form.filters.situacao"
                  labelType="Situação"
              ></sigfoco-select-ativo>
              <v-col cols="3">
                <v-text-field
                    label="Setor"
                    v-model="form.filters.setor"
                    outlined
                    dense
                ></v-text-field>
                </v-col>
                <sigfoco-date-picker
                    :cols="2"
                    label="Data Início"
                    v-model="form.filters.dataInicio"
                    removeIcon
                    outlined
                    dense
                ></sigfoco-date-picker>
                <sigfoco-date-picker
                    :cols="2"
                    v-model="form.filters.dataFim"
                    label="Data Final"
                    removeIcon
                    outlined
                    dense
                ></sigfoco-date-picker>
            </v-row>
             <div class="text-center">
            <v-col cols="12">
              <sigfoco-tooltip
                text="Buscar"
                icon="mdi-magnify"
                @click="buscarRelatorios"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                text="Limpar"
                icon="mdi-eraser"
                @click="resetForm"
              ></sigfoco-tooltip>
            </v-col>
          </div>
        </v-form>
        <v-data-table
            class="mt-5 printable"
            :headers="headersAnalitico"
            :items="form.lists.listRelatorios"
            :items-per-page="form.itemsPerPage"
            :footer-props="$footerProps"
            sort-by="dataHoraAcao"
            :sort-desc="true"
            item-key="eventoId"
            show-expand
            :expanded.sync="expanded"
        >
            <template v-slot:[`item.nome`]="{ item }">
                {{ item.nome }}
            </template>
            <template v-slot:[`item.sigla`]="{ item }">
                {{ item.sigla }}
            </template>
            <template v-slot:[`item.secretaria`]="{ item }">
              {{ item.secretaria }}
            </template>
            <template v-slot:[`item.situacao`]="{ item }">
                <sigfoco-label-ativo-inativo :ativo="item.ativo"></sigfoco-label-ativo-inativo>
            </template>
            <template v-slot:[`item.dataHoraAcao`]="{ item }">
                {{ $formatarDataHora(item.dataHoraAcao) }}
            </template>
            <template v-slot:[`item.acao`]="{ item }">
                {{ item.acao }}
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td class="abas" :colspan="headers.length">
                <v-chip-group active-class="primary--text" column>
                    <v-chip 
                    class="chip-permissao" 
                    v-for="(setor,  i) in item.setores" 
                    :key="i"
                    >
                    <v-icon class="abas" small>mdi-account-multiple</v-icon>
                    {{ setor.nome }}
                    </v-chip>
                </v-chip-group>
                </td>
            </template>
        </v-data-table>
        <sigfoco-buttons
          v-if="form.lists.listRelatorios.length"
          actionText="Baixar PDF"
          cancelText="Baixar CSV"
          @click="baixarRelatorioPdf"
          @cancel="baixarCSVRelatorio"
        ></sigfoco-buttons>
      </v-container>
    </div>
  </template>
  
<script>
    import pageLoadingMixin from "mixins/page-loading.mixin";
    import RelatorioDeLog from "services/relatorios-log/manter-organograma-log.service"
    export default {
        name: "RelatorioLogOrganograma",
        mixins: [pageLoadingMixin, RelatorioDeLog],
    
        data: () => ({
        onReport: false,
        expanded: [],
        form: {
            filters: {
                nome: null,
                sigla: null,
                setor: null,
                secretariaId: null,
                situacao: null,
                dataInicio: null,
                dataFim: null,
            },
            lists: {
                listRelatorios: [],
                listaSecretarias: [],
            },
        },
        headersAnalitico: [
            { text: "Nome da Gerência", align: "center", value: "nome" },
            { text: "Sigla da Gerência", align: "center", value: "sigla" },
            { text: "Secretaria Executiva", align: "center", value: "secretaria" },
            { text: "Setor", align: "center", value: "data-table-expand"},
            { text: "Situação", align: "center", value: "situacao" },
            { text: "Data/Hora da ação", align: "center", value: "dataHoraAcao" },
            { text: "Ação", align: "center", value: "acao" },
        ],
        }),
        methods: {
        async buscarRelatorios() {
            const isValid = this.validarDatas();
            if (!isValid) return;
            if (!this.verificarFiltrosPreenchidos()) return;
    
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogOrganograma(this.$montarParamsFilters(preparedRequest));
            this.processarRespostaRelatorio(data);
            } finally {
            this.hidePageLoading();
            }
        },
        validarDatas() {
        const { dataInicio, dataFim } = this.form.filters;
        
        if (dataInicio && dataFim) {
          if (new Date(dataFim) < new Date(dataInicio)) {
            this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
            return false;
          }
          if (new Date(dataInicio) > new Date(dataFim)) {
            this.$notifyWarning("A Data Início não pode ser posterior à Data Final");
            return false;
          }
        }
        return true;
      },
    
        verificarFiltrosPreenchidos() {
          const { nome, sigla, situacao, dataInicio, dataFim, setor, secretariaId } = this.form.filters;
          if (!nome && !sigla && !setor && situacao == null && !dataInicio && !dataFim && !secretariaId) {
              this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
              return false;
          }
          
          return true;
        },
    
        async baixarCSVRelatorio() {
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogCSVOrganograma(this.$montarParamsFilters(preparedRequest));
            this.$baixarRelatorioCSV(data, `SIGFOCO.RelatórioDeLogDeOrganogramaCSV`);
            this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
            this.hidePageLoading();
            }
        },
    
        async baixarRelatorioPdf() {
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogPDFOrganograma(this.$montarParamsFilters(preparedRequest));
            const url = URL.createObjectURL(data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "SIGFOCO.RelatórioDeLogDeOrganograma.pdf");
            document.body.appendChild(link);
            link.click();
            this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
            this.hidePageLoading();
            }
        },
        prepararRequisicao() {
            return {
            nome: this.form.filters.nome,
            sigla: this.form.filters.sigla,
            setor: this.form.filters.setor,
            dataInicio: this.form.filters.dataInicio,
            dataFim: this.form.filters.dataFim,
            ativo: this.form.filters.situacao,
            };
        },
    
        processarRespostaRelatorio(data) {
            this.form.lists.listRelatorios = data.relatorio?.logs;
        },

        resetForm() {
          this.form.filters.dataInicio = null;
          this.form.filters.dataFim = null;
    
          this.$nextTick(() => {
            this.$set(this.form.filters, 'dataInicio', null);
            this.$set(this.form.filters, 'dataFim', null);
          });
          this.form.filters.nome = null;
          this.form.filters.sigla = null;
          this.form.filters.situacao = null;
          this.form.filters.setor = null;
          this.form.filters.secretariaId = null;
          this.form.lists.listRelatorios = [];
          this.expanded = [];
        }
      },
      mounted() {
        this.$obterListaSecretarias().then(({ data }) => {
          this.form.lists.listaSecretarias = data.lista;
        });
      }
    };
</script>